<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">{{ measurePageTitle }}</h2>
    </div>

    <div fxLayout="row" fxLayoutGap="5px" class="add-button-style">
      <span
        #myMeasuresButton
        fxLayoutAlign="end"
        class="buttons-container"
        (click)="loadMyMeasures()"
      >
        {{ myMeasureTitle() }}
      </span>
      <div
        class="card-view-controls"
        [style.flexDirection]="rtlEnabled ? 'row-reverse' : 'row'"
      >
        <abc-button
          [hint]="'card'"
          [class.selected]="viewType === AbcCardViewType.Card"
          (onClick)="changeViewType(AbcCardViewType.Card)"
        >
          <ng-container *dxTemplate="let item of 'content'">
            <mat-icon
              [svgIcon]="res?.svgName('Ubt-Card-Icon-Image')"
            ></mat-icon>
          </ng-container>
        </abc-button>
        <abc-button
          [hint]="'grid'"
          [class.selected]="viewType === AbcCardViewType.Grid"
          (onClick)="changeViewType(AbcCardViewType.Grid)"
        >
          <ng-container *dxTemplate="let item of 'content'">
            <mat-icon
              [svgIcon]="res?.svgName('Ubt-Grid-Icon-Image')"
            ></mat-icon>
          </ng-container>
        </abc-button>
      </div>
    </div>
  </div>
  <div fxLayout="row" class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      @if (viewType === AbcCardViewType.Grid) {
        <abc-grid
          #measureGrid
          id="measureGrid"
          class="grid-group-by-Style chech-box-Column custome-export-style abc-grid-custom-style grid-adaptive-mode"
          [height]="'100%'"
          [width]="'100%'"
          [rowAlternationEnabled]="false"
          [noDataText]="noDataText"
          [columnChooser]="{ search: { enabled: true }, enabled: true }"
          [showRowLines]="false"
          [selectionMode]="selectionMode"
          [columns]="columnsHeader"
          [dataSource]="measures"
          (onRowDblClick)="openMeasureDetails($event)"
          (onContentReady)="onContentReady($event)"
          (onCellHoverChanged)="hoverTooltip($event)"
          (onCellPrepared)="onCellPrepared($event)"
          (onCellClick)="onCellClick($event)"
          (onExporting)="dataService.onExporting($event, exportFileName)"
          [columnHidingEnabled]="true"
          [wordWrapEnabled]="true"
          [columnAutoWidth]="false"
          (onToolbarPreparing)="onToolbarPreparing($event)"
        >
          <div *dxTemplate="let data of 'archivedTemplate'">
            <abc-check-box
              class="checkbox-text-left"
              [text]="
                dataService.res('Ubt-Measure-List-Display-Archived-Measures')
              "
              [(value)]="isArchivedVisible"
              (onValueChanged)="setArchivedVisibility($event)"
            >
            </abc-check-box>
          </div>
          <dxo-export
            [enabled]="true"
            [allowExportSelectedData]="false"
            [formats]="['pdf', 'xlsx']"
          ></dxo-export>
          <dxo-header-filter [visible]="true"></dxo-header-filter>
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-group-panel #dxGroup [visible]="true"></dxo-group-panel>
          <dxo-editing [allowAdding]="false"> </dxo-editing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-filter-panel [visible]="true"></dxo-filter-panel>
          <dxo-search-panel [visible]="true"> </dxo-search-panel>
          <dxo-summary>
            <dxi-group-item
              column="ParentId"
              summaryType="count"
              displayFormat="{{ dataService.res('Ubt-Report-Total') }}: {0}"
            >
            </dxi-group-item>
            <dxi-total-item
              column="Designation"
              summaryType="count"
              displayFormat="{{ dataService.res('Ubt-Report-Total') }}: {0}"
            >
            </dxi-total-item>
          </dxo-summary>
        </abc-grid>
      }

      @if (viewType === AbcCardViewType.Card) {
        <div
          class="card-view-header"
          [style.justifyContent]="rtlEnabled ? 'flex-start' : 'flex-end'"
        >
          <abc-check-box
            class="checkbox-text-right"
            [text]="
              dataService.res('Ubt-Measure-List-Display-Archived-Measures')
            "
            [(value)]="isArchivedVisible"
            (onValueChanged)="setArchivedVisibility($event)"
          >
          </abc-check-box>
          @if (filters && filters.length > 0) {
            <abc-filter
              #abcFilter
              class="card-abcFilter"
              [filters]="filters"
              [dataSource]="measures"
              (dataSourceChange)="onFilterDataSourceChange($event)"
            ></abc-filter>
          }
        </div>

        <ubt-measure-card
          #measureCard
          [measures]="measures"
          [noDataText]="noDataText"
          [maxScore]="maxScore"
          [ratingCount]="ratingCount"
          (cardClick)="onCardClick($event)"
          (favoriteToggle)="onFavoriteToggle($event)"
          (contextMenuOpen)="onContextMenuOpen($event)"
        ></ubt-measure-card>
      }

      <dx-tooltip
        [target]="statusTooltipTarget"
        [visible]="isStatusTooltipVisible"
      >
        <div *dxTemplate="let data of 'content'">
          <div class="tooltip-target">
            {{ statusTooltipText }}
          </div>
        </div>
      </dx-tooltip>

      <dx-tooltip
        [target]="scoreTooltipTarget"
        [visible]="isScoreTooltipVisible"
        position="top"
      >
        <div *dxTemplate="let data of 'content'">
          @if (scoreTooltipData) {
            <div class="score-tooltip">
              <div class="tooltip-row">
                <span
                  [innerHTML]="iconSvg | safeHtml"
                  class="icon-small"
                ></span>
                <span>{{ dataService.res("Ubt-Measure-List-Effort") }}:</span>
                <strong>{{ scoreTooltipData.Effort }}/{{ ratingCount }}</strong>
              </div>

              <div class="tooltip-row">
                <span
                  [innerHTML]="euroSvg | safeHtml"
                  class="curr-icon-small"
                ></span>
                <span>{{ dataService.res("Ubt-Measure-List-Benefit") }}:</span>
                <strong
                  >{{ scoreTooltipData.Benefit }}/{{ ratingCount }}</strong
                >
              </div>

              <div class="tooltip-row">
                <span
                  [innerHTML]="euroSvg | safeHtml"
                  class="curr-icon-small"
                ></span>
                <span>P&amp;L:</span>
                <strong>{{
                  scoreTooltipData.Impact
                    | currency: "EUR" : "symbol" : "1.0-0" : locale
                }}</strong>
              </div>

              <div class="tooltip-row">
                <span
                  [innerHTML]="euroSvg | safeHtml"
                  class="curr-icon-small"
                ></span>
                <span>{{ dataService.res("Ubt-Measure-List-Cost") }}:</span>
                <strong
                  >{{
                    scoreTooltipData.Cost
                      | currency: "EUR" : "symbol" : "1.0-0" : locale
                  }}
                </strong>
              </div>
            </div>
          }
        </div>
      </dx-tooltip>

      <div
        *appCheckPermission="{
          context: PermissionContext.Measure,
          action: Action.CREATE,
        }"
      >
        <dx-speed-dial-action
          icon="add"
          [index]="1"
          (onClick)="openCreationPopup()"
        >
        </dx-speed-dial-action>
      </div>
    </div>
  </div>

  <abc-popup
    #measureCreationForm
    fxLayout="column"
    fxLayoutAlign="center center"
    [width]="'90%'"
    [maxWidth]="700"
    [height]="'auto'"
    [maxHeight]="'85%'"
    [showTitle]="true"
    title="{{ dataService.res('Ubt-MeasureList-Create-Measure') }}"
    [showCloseButton]="true"
    (onHidden)="navigateAfterClose()"
  >
    <div class="scrollable-container">
      <ubt-geods-create-measure
        (closePopup)="closeCreationPopup($event)"
      ></ubt-geods-create-measure>
    </div>
  </abc-popup>

  <abc-popup
    #confirmDeletePopup
    [width]="'90%'"
    [maxWidth]="600"
    [height]="700"
    fxLayout="column"
    fxLayoutAlign="center center"
    [height]="'auto'"
    [title]="dataService.res('Ubt-MeasureList-Confirm-Delete')"
    [showCloseButton]="true"
  >
    <div
      class="dx-card popup-card-paddings card-radius"
      fxLayout="column"
      fxLayoutGap="20px"
      fxFlexFill
    >
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
        {{ dataService.res("Ubt-MeasureList-Delete-Message") }}
      </div>
      <dxi-item
        itemType="group"
        fxLayout="row"
        fxLayoutAlign="end end"
        fxLayoutGap="20px"
      >
        <dx-button
          class="submit-button"
          [text]="dataService.res('Ubt-Company-Icon-Delete')"
          (onClick)="removeMeasure()"
        >
        </dx-button>
        <dx-button
          class="cancel-button"
          [text]="dataService.res('Ubt-Company-Button-Cancel')"
          (onClick)="abortDelete()"
        >
        </dx-button>
      </dxi-item>
    </div>
  </abc-popup>
</div>

<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
